'use client';

import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { ShippingAddress } from '../types/cart';

interface UserProfile {
  firstName: string;
  lastName: string;
  email: string;
  provider?: 'email' | 'google' | 'facebook' | 'apple';
  id?: number; // ID de PrestaShop
  active?: number; // Estado activo en PrestaShop
}

interface UserState {
  isLogged: boolean;
  profile: UserProfile | null;
  addresses: ShippingAddress[];
  customerId: number | null; // ID del cliente en PrestaShop

  setIsLogged: (value: boolean) => void;
  setProfile: (profile: UserProfile | null) => void;
  setCustomerId: (id: number | null) => void;
  addAddress: (address: ShippingAddress) => void;
  getDefaultAddress: () => ShippingAddress | null;
  clearUserData: () => void; // Limpiar todos los datos del usuario
}

export const useUserStore = create<UserState>()(
  persist(
    (set, get) => ({
      isLogged: false,
      profile: null,
      customerId: null,
      addresses: [],

      setIsLogged: (value: boolean) => set({ isLogged: value }),
      setProfile: (profile: UserProfile | null) => set({ profile }),
      setCustomerId: (id: number | null) => set({ customerId: id }),
      addAddress: (address: ShippingAddress) => set((state) => ({ addresses: [address, ...state.addresses] })),
      getDefaultAddress: () => {
        const { addresses } = get();
        return addresses.length > 0 ? addresses[0] : null;
      },
      clearUserData: () => set({ 
        isLogged: false, 
        profile: null, 
        customerId: null, 
        addresses: [] 
      })
    }),
    {
      name: 'user-storage',
      partialize: (state) => ({
        isLogged: state.isLogged,
        profile: state.profile,
        customerId: state.customerId,
        addresses: state.addresses
      })
    }
  )
);


